<template>
    <el-select
        v-model="value"
        v-loadmore="load"
        clearable
        style="width: 140px"
        size="mini"
        filterable
        placeholder="请选择属性值"
        :filter-method="filterMethod"
        :popper-append-to-body="false"
        @clear="change"
    >
        <el-option v-for="(item, i) in list" :key="i" :label="item.value" :value="item.value" @click.native="change" />
    </el-select>
</template>

<script>
import { debounce } from 'lodash';

export default {
    directives: {
        loadmore: {
            bind(el, binding) {
                const SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap');
                SELECTWRAP_DOM.addEventListener(
                    'scroll',
                    debounce(function () {
                        const CONDITION = this.scrollHeight - this.scrollTop <= this.clientHeight;
                        if (CONDITION) {
                            binding.value();
                        }
                    }, 300)
                );
            },
        },
    },
    props: {
        el: Object,
    },
    data() {
        const index = 1;
        const size = 30;
        let item = this.el.featureIdValues.find((o) => o.vid === this.el.vid);
        return {
            index,
            size,
            value: item ? item.value : '',
            opts: this.el.featureIdValues,
        };
    },
    computed: {
        list() {
            // let item = this.el.featureIdValues.find((o) => o.vid === this.value);
            // let opts = item ? [item] : [];
            // return opts.concat(this.opts.slice(0, this.index * this.size));
            return this.opts.slice(0, this.index * this.size);
        },
    },
    methods: {
        load() {
            this.index++;
        },
        change() {
            let vid = this.el.featureIdValues.find((o) => o.value === this.value);
            vid = vid ? vid.vid : '';
            // eslint-disable-next-line vue/no-mutating-props
            this.el.vid = vid;
            this.index = 1;
            this.opts = this.el.featureIdValues;
            this.$emit('selectChanged', this.el, vid);
        },
        filterMethod: debounce(function (str) {
            this.$el.querySelector('.el-select-dropdown__wrap').scrollTo(0, 0);
            this.value = str;
            this.index = 1;
            this.opts = str
                ? this.el.featureIdValues.filter((o) => (o.value + '').includes(str))
                : this.el.featureIdValues;
        }, 300),
    },
};
</script>

<style></style>
